import colors from "../../theme/base/colors";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    fontFamily: '"Montserrat", sans-serif !important',
  },
  body: {
    fontFamily: '"Montserrat", sans-serif !important',
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    fontFamily: '"Montserrat", sans-serif !important',
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
